import { AppComponent } from "../../../app.component";
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core'; 
import { SpinnerComponent } from "./spinner.component";

@Injectable({
  providedIn: 'root'
})

export class SpinnerService {
  private overlayRef: OverlayRef = null;

  constructor(private overlay: Overlay) { }

  public show(message = '') {
    // Returns an OverlayRef (which is a PortalHost)

    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create(); 
    }

    // Create ComponentPortal that can be attached to a PortalHost
    const spinner = new ComponentPortal(SpinnerComponent);
      
    // run in async context for triggering "tick", thus avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      if (this.overlayRef.hasAttached()) {
        this.overlayRef.detach();
      }
      const component = this.overlayRef.attach(spinner); // Attach ComponentPortal to PortalHost

      // TODO: set message
      component.instance.message = message;
    });
  }

  public hide() {
    if (!!this.overlayRef) {
      this.overlayRef.detach();
    }
  }
}
